export default {
  setMsTeamsConfiguration(state, msTeamsConfiguration) {
    state.msTeamsConfiguration = msTeamsConfiguration;
  }
};
